import React, { useEffect, useState } from "react";
import "./FormRegister.css";
import {
  addVpa,
  getOrganisation,
  updateVpasPriority,
  viewVpas,
} from "../../../config/LiveApi";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";

const FormRegister = () => {
  const token = useSelector((state) => state.userReducer.token);
  const [orgs, setOrgs] = useState([]);
  const [draggedVPA, setDraggedVPA] = useState(null);
  const [hoveredVPA, setHoveredVPA] = useState(null);
  const [newVpa, setNewVpa] = useState(null);
  const [vpa, setVpa] = useState(null);
  const [totalLimit, setTotalLimit] = useState(0);
  const [dailyLimit, setDailyLimit] = useState(0);
  const [loading, setLoading] = useState(true);
  const [updatingOrgIndex, setUpdatingOrgIndex] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedOrganisation, setSelectedOrganisation] = useState(null);
  const [organization, setOrganization] = useState(null);

  const handleDragStart = (orgIndex, vpa) => {
    if (updatingOrgIndex === orgIndex) return;
    setDraggedVPA({ orgIndex, vpa });
  };

  const handleDragEnter = (orgIndex, targetVpa) => {
    if (updatingOrgIndex === orgIndex) return;
    setHoveredVPA({ orgIndex, targetVpa });
  };

  const handleDrop = async () => {
    if (!draggedVPA || !hoveredVPA) return;

    const { orgIndex: fromOrgIndex, vpa: dragged } = draggedVPA;
    const { orgIndex: toOrgIndex, targetVpa: target } = hoveredVPA;

    if (fromOrgIndex !== toOrgIndex || updatingOrgIndex === fromOrgIndex)
      return;

    setUpdatingOrgIndex(fromOrgIndex);

    const newOrgs = [...orgs];
    const vpaList = [...newOrgs[fromOrgIndex].vpas];

    const fromIndex = vpaList.findIndex(
      (v) => v.providerVpa === dragged.providerVpa
    );
    const toIndex = vpaList.findIndex(
      (v) => v.providerVpa === target.providerVpa
    );

    if (fromIndex === -1 || toIndex === -1) return;

    vpaList.splice(fromIndex, 1);
    vpaList.splice(toIndex, 0, dragged);

    vpaList.forEach((vpa, i) => (vpa.priority = i + 1));

    newOrgs[fromOrgIndex].vpas = vpaList;
    setOrgs(newOrgs);
    setDraggedVPA(null);
    setHoveredVPA(null);

    const payload = vpaList.map((vpa) => ({
      providerVpa: vpa.providerVpa,
      priority: vpa.priority,
    }));

    try {
      await updateVpasPriority(token, payload);
      toast.success("Priority updated successfully");
    } catch (error) {
      toast.error("Something went wrong!!");
    } finally {
      setUpdatingOrgIndex(null);
    }
  };

  const fetchAllVpas = async () => {
    try {
      setLoading(true);
      const response = await viewVpas(token);
      const raw = response || [];

      const grouped = raw.reduce((acc, item) => {
        const key = item.orgName || "Unknown Org";
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      const formatted = Object.entries(grouped).map(([orgName, vpas]) => ({
        orgName,
        vpas: vpas.sort((a, b) => a.priority - b.priority),
      }));

      setOrgs(formatted);
    } catch (error) {
      console.log("❌ Failed to fetch VPAs", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAllOrgs = async () => {
    try {
      const response = await getOrganisation(token);
      setOrganization(response.data);
    } catch (error) {}
  };
  useEffect(() => {
    fetchAllVpas();
    fetchAllOrgs();
  }, [token]);

  const providerOptions = [{ label: "muffin-pay", value: "muffin-pay" }];

  const organisationOptions = organization?.map((org) => ({
    label: org.orgName,
    value: org.orgName,
  }));

  const handleAddVpa = async () => {
    try {
      const payload = {
        orgName: selectedOrganisation.value,
        vpaProvider: selectedProvider.value,
        vpa: vpa,
        totalLimit: totalLimit,
        dailyLimit: dailyLimit,
      };
      await addVpa(token, payload);
      toast.success("VPA added successfully.");
      setVpa(null);
      setTotalLimit(0);
      setDailyLimit(0);
      setSelectedOrganisation(null);
      setSelectedProvider(null);
      setNewVpa(null);
      fetchAllVpas();
    } catch (error) {
      toast.error("Something went wrong.");
    }
  };

  return (
    <div className="webhooks-report-table-container">
      <h2 className="webhooks-report-table-title">
        VPA Pool Priority Management
      </h2>

      {loading ? (
        <p>Loading VPA data...</p>
      ) : (
        orgs.map((org, orgIndex) => (
          <div key={org.orgName} style={{ marginBottom: 40 }}>
            <div className="flex">
              <div>
                <h3 style={{ color: "#3e8e41", marginBottom: 10 }}>
                  {org.orgName}{" "}
                  {updatingOrgIndex === orgIndex && (
                    <span style={{ fontSize: 14, color: "#fc8019" }}>
                      (Updating...)
                    </span>
                  )}
                </h3>
              </div>
              <div>
                <button
                  className="add-vpa-button"
                  onClick={() => {
                    setNewVpa(org.orgName);
                    setSelectedOrganisation({
                      label: org.orgName,
                      value: org.orgName,
                    });
                  }}
                >
                  Add Vpa
                </button>
              </div>
            </div>
            <div className="scrollable-table-container">
              <table className="inner-detail-table">
                <thead>
                  <tr>
                    <th>Priority</th>
                    <th>VPA</th>
                  </tr>
                </thead>
                <tbody>
                  {org.vpas.map((vpa, idx) => (
                    <tr
                      key={vpa.id || vpa.providerVpa}
                      className={`merchant-detail-row ${
                        draggedVPA?.vpa?.providerVpa === vpa.providerVpa
                          ? "dragging"
                          : ""
                      } ${
                        hoveredVPA?.targetVpa?.providerVpa === vpa.providerVpa
                          ? "hovered"
                          : ""
                      }`}
                      draggable={updatingOrgIndex !== orgIndex}
                      onDragStart={() => handleDragStart(orgIndex, vpa)}
                      onDragEnter={() => handleDragEnter(orgIndex, vpa)}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={handleDrop}
                    >
                      <td className="priority-column">{idx + 1}</td>
                      <td>{vpa.providerVpa}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}

      {newVpa && (
        <div className="vpa-modal-overlay">
          <div className="vpa-modal">
            <h3>Add New VPA to {newVpa}</h3>
            <div>
              <div className="modal-inputs">
                <Select
                  options={organisationOptions}
                  value={selectedOrganisation}
                  onChange={(selected) => setSelectedOrganisation(selected)}
                  placeholder="Select Organisation"
                  required
                />
                <Select
                  options={providerOptions}
                  value={selectedProvider}
                  onChange={(selected) => setSelectedProvider(selected)}
                  placeholder="Select VPA Provider"
                  required
                />
              </div>
              <input
                value={vpa}
                onChange={(e) => setVpa(e.target.value)}
                name="providerId"
                placeholder="Enter VPA"
                required
              />
              <p>Daily Limit</p>
              <input
                value={dailyLimit}
                onChange={(e) => setDailyLimit(e.target.value)}
                name="dailyLimit"
                type="number"
                placeholder="Daily Limit"
                required
              />
              <p>Total Limit</p>
              <input
                value={totalLimit}
                onChange={(e) => setTotalLimit(e.target.value)}
                name="totalLimit"
                type="number"
                placeholder="Total Limit"
                required
              />
              <div className="modal-actions">
                <button type="submit" onClick={handleAddVpa}>
                  Add
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setVpa(null);
                    setTotalLimit(0);
                    setDailyLimit(0);
                    setSelectedOrganisation(null);
                    setSelectedProvider(null);
                    setNewVpa(null);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormRegister;
